var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("questionnaireResult"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
              on: { select: _vm.modelChange }
            },
            [
              _c("el-menu-item", { attrs: { index: "0" } }, [
                _vm._v(_vm._s(_vm.$t("statisticsLabel")))
              ]),
              _c("el-menu-item", { attrs: { index: "1" } }, [
                _vm._v(_vm._s(_vm.$t("userListLabel")))
              ])
            ],
            1
          ),
          _vm.activeIndex == 0
            ? _c("div", { staticClass: "modleItem" }, [
                _c(
                  "div",
                  { staticClass: "statistics-scroll-area" },
                  _vm._l(_vm.questionResult, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.question_id,
                        staticClass: "question-result-card"
                      },
                      [
                        _c("div", { staticClass: "q-title-row" }, [
                          _c(
                            "span",
                            {
                              staticClass: "q-badge",
                              class:
                                item.type === 1 ? "type-select" : "type-input"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.type === 1
                                      ? _vm.$t("choiceQuestion")
                                      : _vm.$t("fillBlankQuestion")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c("span", { staticClass: "q-title" }, [
                            _vm._v(
                              _vm._s(index + 1) + ". " + _vm._s(item.title)
                            )
                          ]),
                          item.required
                            ? _c("span", { staticClass: "q-required" }, [
                                _vm._v("* " + _vm._s(_vm.$t("requiredLabel")))
                              ])
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "q-meta-info" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("submitPeopleCount", {
                                  count: item.answered_count
                                })
                              )
                            )
                          ])
                        ]),
                        item.type === 1
                          ? _c(
                              "div",
                              { staticClass: "options-result-list" },
                              _vm._l(item.options, function(opt) {
                                return _c(
                                  "div",
                                  {
                                    key: opt.option_id,
                                    staticClass: "option-result-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "option-info-text" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "option-desc" },
                                          [_vm._v(_vm._s(opt.desc))]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "option-count-num" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("peopleWithPercent", {
                                                  count: opt.count,
                                                  percent: opt.percentage
                                                })
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("el-progress", {
                                      attrs: {
                                        percentage: opt.percentage,
                                        "stroke-width": 12,
                                        colors: _vm.customColors,
                                        status: "success"
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _c("div", { staticClass: "text-result-box" }, [
                              _c("div", { staticClass: "text-summary" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("validAnswerCountLabel"))
                                  ),
                                  _c("strong", [_vm._v(_vm._s(item.count))]),
                                  _vm._v(" " + _vm._s(_vm.$t("timesUnit")))
                                ]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("validAnswerPercentLabel"))
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(item.percentage) + "%")
                                  ])
                                ])
                              ])
                            ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm.activeIndex == 1
            ? _c(
                "div",
                { staticClass: "modleItem" },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "flex-1",
                              attrs: {
                                filterable: "",
                                placeholder: _vm.$t("pleaseChoose")
                              },
                              on: { change: _vm.Renewal },
                              model: {
                                value: _vm.paramsData.is_prod,
                                callback: function($$v) {
                                  _vm.$set(_vm.paramsData, "is_prod", $$v)
                                },
                                expression: "paramsData.is_prod"
                              }
                            },
                            _vm._l(_vm.severlist, function(item) {
                              return _c("el-option", {
                                key: item.label,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: _vm.$t("pleaseSelectServer")
                              },
                              model: {
                                value: _vm.paramsData.server_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.paramsData, "server_id", $$v)
                                },
                                expression: "paramsData.server_id"
                              }
                            },
                            _vm._l(_vm.serverLists, function(item) {
                              return _c("el-option", {
                                key: item.serverID,
                                attrs: {
                                  label: item.serverName,
                                  value: item.serverID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-date-picker", {
                            staticClass: "flex-1 ",
                            attrs: {
                              "popper-class": "no-atTheMoment",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: _vm.$t("startTime"),
                              align: "right"
                            },
                            model: {
                              value: _vm.paramsData.start_time,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "start_time", $$v)
                              },
                              expression: "paramsData.start_time"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-date-picker", {
                            staticClass: "flex-1 ",
                            attrs: {
                              "popper-class": "no-atTheMoment",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: _vm.$t("endTime"),
                              align: "right"
                            },
                            model: {
                              value: _vm.paramsData.end_time,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "end_time", $$v)
                              },
                              expression: "paramsData.end_time"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("userId")
                            },
                            model: {
                              value: _vm.paramsData.user_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "user_id", $$v)
                              },
                              expression: "paramsData.user_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "operationBut", attrs: { span: 4 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.exportData()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("export")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.reqLoading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getList(1)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("search")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.reqLoading,
                          expression: "reqLoading"
                        }
                      ],
                      attrs: { data: _vm.tableData, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "user_id", label: _vm.$t("userId") }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "role_id", label: _vm.$t("roleId") }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "role_name", label: _vm.$t("roleName") }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "server_name",
                          label: _vm.$t("serverName")
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "answer_time",
                          label: _vm.$t("answerTime")
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("operation"),
                          width: "80",
                          align: "center",
                          fixed: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("div", { staticClass: "x-c" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "controlsBtn",
                                        on: {
                                          click: function($event) {
                                            return _vm.$refs.questionDetail.init(
                                              row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("details")))]
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3603948920
                        )
                      })
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      layout: "total,sizes, prev, pager, next",
                      "current-page": _vm.paramsData.page,
                      total: _vm.total,
                      page_size: _vm.paramsData.page_size
                    },
                    on: {
                      "current-change": _vm.getList,
                      "size-change": _vm.sizeChange
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("questionDetail", { ref: "questionDetail" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }